import React, { useState } from "react";
import { Modal, Rate, Button } from "antd";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";
import ThanksModal from "./ThanksModal";
import { useParams } from "react-router";
const feedbackOptions = [
  "Quality Items",
  "Smart Bagging",
  "Efficient",
  "Helpful Chat",
  "Good Replacement",
  "Delivered with Care",
  "Friendly Service",
  "Great Communication",
];

const LeaveFeedbackModal = ({ open, onClose }) => {
  const [rating, setRating] = useState(0);
  const [thanksOpen, setThanksOpen] = useState(false);
  const { id } = useParams();
  const [selected, setSelected] = useState([]);
  const { leaveFeedback } = useStore();
  const toggleOption = (option) => {
    setSelected((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = async (orderId) => {
    try {
      const comment = selected.join(", ");
      const response = await leaveFeedback({ rating, comment, orderId });
      if (response.status === 200 || response.status === 201) {
        onClose();
        setThanksOpen(true);
      }
    } catch (error) {
      onClose();
      ShowToast(error.message, Severty.ERROR);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        centered
        className="feedback-modal"
      >
        <div className="track-modal-header">
          <h6>Leave feedback</h6>
          <p>Rate your last order. Your review will help us improve</p>
        </div>

        <Rate className="feadback-rate" value={rating} onChange={setRating} />

        <div className="feadback-tags-main">
          <h6>Tell us more</h6>
          <div className="feedback-tags">
            {feedbackOptions.map((option) => (
              <span
                key={option}
                className={`tag ${selected.includes(option) ? "active" : ""}`}
                onClick={() => toggleOption(option)}
              >
                {option}
              </span>
            ))}
          </div>
        </div>
        <div className="order-modal-section">
          <Button
            className="fill-button-smal "
            onClick={() => handleSubmit(id)}
          >
            Submit
          </Button>

          <Button className="social-btn" onClick={onClose}>
            Skip
          </Button>
        </div>
      </Modal>
      <ThanksModal open={thanksOpen} onClose={() => setThanksOpen(false)} />
    </>
  );
};

export default LeaveFeedbackModal;
